export default __webpack_public_path__ + "static/media/eyeOn.d049019f.svg";